module.exports = __webpack_public_path__ + "img/19_38.e0424def.png";